/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react"
import { ICWProps } from "."
import { NAVIGATION_DESIGN_TYPE, NAVIGATION_POSITION_TYPE, NAVIGATION_SIZE_TYPE, NAVIGATION_THEME_TYPE, NAVIGATION_TYPE } from "src/libs/useful/gallery/Gallery"


/* Protopia Ecosystem component */
export interface ICarouselDesignHandlerProps extends ICWProps {
   
}
const CarouselDesignHandler = (props: ICarouselDesignHandlerProps): JSX.Element => {
    const [i, setI] = useState<number>(0)
    const variants: any[] = useMemo(() => {
        let variants: any[] = []
        Object.values( NAVIGATION_DESIGN_TYPE ).forEach(key => {            
            Object.values( NAVIGATION_SIZE_TYPE ).forEach(key2 => {
                Object.values( NAVIGATION_THEME_TYPE ).forEach(key3 => {
                    Object.values( NAVIGATION_TYPE ).forEach(key4 => {
                        let variant: any = { 
                            carousel_nav_type: key,                
                            carousel_nav_size: key2,
                            carousel_nav_theme: key3,
                            carousel_nav: key4,
                        }
                        variants.push( variant )
                    })
                })
            })
        })
        return variants
    },  [])
    useEffect(() => { 
        setI( variants.findIndex(v => v.carousel_nav_type === props.carousel_nav_type && v.carousel_nav_size === props.carousel_nav_size ) || 0 )

    }, [variants])

    const onClick = () => {
        //const next = ( i + 1 ) % variants.length
        const next = Math.floor(Math.random() * variants.length)
        setI( next )
        props.onChange({
            ...props,
            ...variants[ next ],
        })
    }

    //carousel_nav_type

    return [ NAVIGATION_POSITION_TYPE.MIDDLE_INNER, NAVIGATION_POSITION_TYPE.MIDDLE_OUTER].includes( props.carousel_nav_position )
        ?
        <>
            <div className={`carousel-design carousel-${ props.carousel_nav_position }pos-left bg-${props.carousel_nav_theme}`} onClick={onClick}>
                <div className={`cw-left8 fas fa-${props.carousel_nav_type}-left p-1`} /> 
            </div>
            <div className={`carousel-design carousel-${ props.carousel_nav_position }pos-right bg-${props.carousel_nav_theme}`} onClick={onClick}> 
                <div className={`cw-right8 fas fa-${props.carousel_nav_type}-right p-1`} /> 
            </div> 
        </>
        :
        <div className={`carousel-design carousel-${ props.carousel_nav_position }pos bg-${props.carousel_nav_theme}`} onClick={onClick}>
            <div>
                <div className={`cw-left8 fas fa-${props.carousel_nav_type}-left p-1`} />
                <div className={`cw-right8 fas fa-${props.carousel_nav_type}-right p-1`} />
            </div>
        </div>   
}
export default CarouselDesignHandler